import { Component, Input } from '@angular/core';

import { ActivityEventNames, CanvassingTypes, SearchActivityEvents } from 'generated/graphql';

import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

@Component({
  selector: 'app-canvass-attempt-event',
  templateUrl: './canvass-attempt-event.component.html'
})

export class ASCanvassAttemptEventComponent extends WithDisposableSubject() {

  @Input() item: SearchActivityEvents.Node;

  /**
   *
   */
  constructor(
  ) {
    super();
  }


  canvassResult() {
    if (this.item.name === ActivityEventNames.CreateContactAttemptActionContacted) {
      return `contacted`;
    }

    return `attempted to canvass`;
  }

  isHomeVisit() {
    return this.item?.payload.action.canvassingType === CanvassingTypes.HomeVisit;
  }

  isInPerson() {
    return this.item?.payload.action.canvassingType === CanvassingTypes.InPersonVisit;
  }

  isPhone() {
    return this.item?.payload.action.canvassingType !== CanvassingTypes.HomeVisit &&
      this.item?.payload.action.canvassingType !== CanvassingTypes.InPersonVisit;
  }

  canvassSubResult() {
    if (this.item.name === ActivityEventNames.CreateContactAttemptActionMarkedAsBad) {
      return 'marked as bad';
    }

    if (this.item.name === ActivityEventNames.CreateContactAttemptActionMarkedAsDoNotContact) {
      return 'do not contact';
    }

    if (this.item.name === ActivityEventNames.CreateContactAttemptActionAttempted) {
      return 'attempted';
    }

    if (this.item.name === ActivityEventNames.CreateContactAttemptActionContacted) {
      return 'contacted';
    }
  }

  getHomeWorkMobile() {
    const type = this.item.payload?.phoneNumber?.type || '';
    if (type.includes('home')) {
      return 'Home';
    }
    if (type.includes('cell')) {
      return 'Mobile';
    }
    if (type.includes('work')) {
      return 'Work';
    }
    return '';
  }

  getStatus() {
    return (this.item.payload.address || this.item.payload.phoneNumber)?.status;
  }

  getSubscribed() {
    return (this.item.payload.address || this.item.payload.phoneNumber)?.subscribed;
  }

}
